import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
    fill?: string;
};

export const ElevatorIcon = ({ width = 60, height = 60, fill = 'currentColor', ...props }: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_6828_51817)">
                <g clipPath="url(#clip1_6828_51817)">
                    <path
                        d="M56.25 66.9742H53.8951V20.6312C53.8951 20.3564 53.6694 20.1308 53.3946 20.1308H6.84554C6.5708 20.1308 6.34512 20.3564 6.34512 20.6214V66.9742H4V20.6312C4 19.0612 5.27559 17.7856 6.84554 17.7856H53.4045C54.9744 17.7856 56.2598 19.0612 56.2598 20.641V66.9742H56.25Z"
                        fill={fill}
                    />
                    <path
                        d="M20.2692 33.9955C22.7321 33.9955 24.7338 31.9938 24.7338 29.531C24.7338 27.0681 22.7321 25.0664 20.2692 25.0664C17.8064 25.0664 15.8047 27.0681 15.8047 29.531C15.8047 31.9938 17.8064 33.9955 20.2692 33.9955ZM17.7083 29.531C17.7083 28.118 18.8563 26.97 20.2692 26.97C21.6822 26.97 22.8302 28.118 22.8302 29.531C22.8302 30.9439 21.6822 32.0919 20.2692 32.0919C18.8563 32.0919 17.7083 30.9439 17.7083 29.531Z"
                        fill={fill}
                    />
                    <path
                        d="M23.9293 34.9863H16.5996C14.5587 34.9863 12.9004 36.6446 12.9004 38.6855V52.2362C12.9004 52.9427 13.4793 53.5216 14.1858 53.5216H16.786V66.9741H18.6896V51.6082H14.8236V38.6953C14.8236 37.7141 15.6184 36.9193 16.5996 36.9193H23.9293C24.9105 36.9193 25.7053 37.7141 25.7053 38.6953V51.6082H21.8491V66.9741H23.7527V53.5216H26.3333C27.0496 53.5216 27.6285 52.9427 27.6285 52.2264V38.6953C27.6285 36.6544 25.9702 34.9961 23.9293 34.9961V34.9863Z"
                        fill={fill}
                    />
                    <path
                        d="M38.9118 33.9955C41.3747 33.9955 43.3764 31.9938 43.3764 29.531C43.3764 27.0681 41.3747 25.0664 38.9118 25.0664C36.449 25.0664 34.4473 27.0681 34.4473 29.531C34.4473 31.9938 36.449 33.9955 38.9118 33.9955ZM36.3508 29.531C36.3508 28.118 37.4989 26.97 38.9118 26.97C40.3248 26.97 41.4728 28.118 41.4728 29.531C41.4728 30.9439 40.3248 32.0919 38.9118 32.0919C37.4989 32.0919 36.3508 30.9439 36.3508 29.531Z"
                        fill={fill}
                    />
                    <path
                        d="M48.1367 54.0122L44.7417 47.3203V39.6275C44.7417 37.0666 42.6615 34.9766 40.0907 34.9766H37.7357C35.1748 34.9766 33.0848 37.0568 33.0848 39.6275V47.3203L29.6799 54.0024C29.5524 54.336 29.6014 54.6991 29.7977 54.9935C29.9939 55.2878 30.3275 55.4546 30.6808 55.4546H35.5378V66.9644H37.4414V53.5609H31.9073L34.9687 47.7128V39.6374C34.9785 38.1263 36.2149 36.8899 37.7259 36.8899H40.0809C41.5919 36.8899 42.8283 38.1263 42.8283 39.6374V47.6637L45.8995 53.5707H40.3654V66.9742H42.269V55.4644H47.1457C47.4989 55.4644 47.8227 55.2976 48.0189 55.0033C48.2152 54.7187 48.2642 54.3459 48.1367 54.0122Z"
                        fill={fill}
                    />
                    <path
                        d="M21.1718 12.0946V4.5H19.9257V12.0848L14.5977 6.75681V8.53282L20.1906 14.116L20.5439 14.4986L26.5097 8.53282V6.75681L21.1718 12.0946Z"
                        fill={fill}
                    />
                    <path
                        d="M39.08 6.90399V14.4986H40.3262V6.90399L45.6542 12.232V10.4658L40.0612 4.87286L39.708 4.5L33.7422 10.4658V12.2418L39.08 6.90399Z"
                        fill={fill}
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_6828_51817">
                    <rect width="60" height="60" fill={fill} />
                </clipPath>
                <clipPath id="clip1_6828_51817">
                    <rect width="52.25" height="62.4743" fill={fill} transform="translate(4 4.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};
